import React from "react"

export const { Consumer: AuthConsumer, Provider: AuthProvider } = React.createContext()
